import BrushTool from './BrushTool.js';

// Named Exports
export { default as BrushTool } from './BrushTool.js';

// Namespace, default export
export default {
  BrushTool,
};
